import { Quotation } from '../../../../../../../../@types/interface';
import { DesktopList } from './Desktop';

interface Props {
  quotationList: Quotation[];
  handleRowClick: (quotation: Quotation) => void;
  onScroll: () => void;
  isLoading: boolean;
  isEmpty?: boolean;
  notFound?: boolean;
}

export const QuotationList = (quotationListProps: Props) => {
  // const { sizeMobile } = useResponsive();

  // if (sizeMobile) return <MobileList {...quotationListProps} />;

  return <DesktopList {...quotationListProps} />;
};
